import React from 'react';
import PropTypes from 'prop-types';

const PHOTO_API_KEY = '3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i';

class PhotoPopup extends React.Component {
  handlePhotoClick() {
    const { photo, handlePhotoClick, messagingChannel } = this.props;
    if (handlePhotoClick) {
      handlePhotoClick(photo.id);
    } else if (messagingChannel) {
      messagingChannel.publish('photo.click', {
        photoId: photo.id
      });
    }
  }

  render() {
    const { imageSize, photo } = this.props;
    const size = imageSize || 'large';
    const photoUrl = photo.photoHash
      ? `https://cdn-assets.alltrails.com/uploads/photo/image/${photo.id}/${size}_${photo.photoHash}.jpg`
      : `/api/alltrails/photos/${photo.id}/image?size=${size}&api_key=${PHOTO_API_KEY}`;
    return (
      <div key={photo} className="map-photo-popup">
        <img src={photoUrl} onClick={this.handlePhotoClick} />
      </div>
    );
  }
}

PhotoPopup.defaultProps = {
  handlePhotoClick: null,
  imageSize: 'large'
};

PhotoPopup.propTypes = {
  handlePhotoClick: PropTypes.func,
  imageSize: PropTypes.string,
  photo: PropTypes.object.isRequired
};

export { PhotoPopup };
